import React, { useCallback, useEffect, useRef, useState } from "react";
import { ImageBackground, StyleSheet, View, Image } from "react-native";
import * as Animatable from "react-native-animatable";
import { TouchableNativeFeedback } from "react-native-gesture-handler";
import YoutubePlayer, { getYoutubeMeta } from "react-native-youtube-iframe";
import Play from "@assets/svg/Play";
import { LEADER_TRAINING } from "@constants/analyticsEventsCT";
import analytics from "@services/analytics";
import parseYoutubeIdfromUrl from "@utils/parseYoutubeIdfromUrl";
import metrics from "../constants/metrics";
import colors from "../constants/color";

const HEIGHT = 220;

const YouTubePlayer = (props) => {
  const {
    title_ref = "",
    video_link,
    image_link = null,
    inline = true,
  } = props;

  const player = useRef();

  const videoId = parseYoutubeIdfromUrl(video_link);

  const [playing, setPlaying] = useState();
  const [played, setPlayed] = useState();
  const [isLoaded, setLoaded] = useState(false);
  const [image, setImage] = useState();
  const [imgRatio, setImgRatio] = useState(0);

  useEffect(() => {
    getYoutubeMeta(videoId)
      .then((response) => {
        setImage(response.thumbnail_url);
      })
      .catch((error) => console.log("meta", error));
  }, [videoId]);

  useEffect(() => {
    if (isLoaded) {
      player.current.seekTo(0);
      setLoaded(false);
    }

    if (playing) {
      setLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [playing]);

  useEffect(() => {
    if (inline && playing && !played) {
      setPlayed(true);
      analytics.trackEvent(LEADER_TRAINING.VIDEO_PLAYED, {
        video_name: title_ref,
      });
    }
    if (!inline && !played) {
      setPlayed(true);
      analytics.trackEvent(LEADER_TRAINING.VIDEO_PLAYED, {
        video_name: title_ref,
      });
    }
  }, [inline, played, playing, title_ref]);

  const onStateChange = useCallback((state) => {
    if (state === "ended") {
      setPlaying();
      setLoaded(false);
    }
  }, []);

  useEffect(() => {
    Image.getSize(image_link, (width, height) => {
      const img_ratio = height / width;
      setImgRatio(img_ratio);
    });
  }, [image_link]);

  return (
    <View style={styles.container}>
      <YoutubePlayer
        ref={player}
        rel={0}
        height={imgRatio === 0 ? HEIGHT : metrics.screenWidth * imgRatio}
        play={playing}
        videoId={videoId}
        onChangeState={onStateChange}
        initialPlayerParams={{
          rel: 0,
          showinfo: 0,
          preventFullScreen: !inline,
        }}
        webViewStyle={{
          flex: 1,
          minHeight: 200,
          height: 300,
          opacity: 0.99,
        }}
        webViewProps={{
          androidHardwareAccelerationDisabled: false,
        }}
      />

      {inline && !isLoaded && (
        <Animatable.View
          animation="fadeIn"
          duration={100}
          style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
          useNativeDriver={true}
        >
          <ImageBackground
            source={{ uri: image_link ?? image }}
            resizeMode="cover"
            style={{
              ...styles.playBackCover,
              height: imgRatio === 0 ? HEIGHT : metrics.screenWidth * imgRatio,
            }}
          >
            <TouchableNativeFeedback
              disabled={playing}
              onPress={() => {
                setPlaying(true);
              }}
              style={styles.playButton}
            >
              {!playing && <Play />}
            </TouchableNativeFeedback>
          </ImageBackground>
        </Animatable.View>
      )}
    </View>
  );
};

export default YouTubePlayer;

const styles = StyleSheet.create({
  container: {
    width: metrics.screenWidth,
    position: "relative",
    marginVertical: 10,
  },
  playBackCover: {
    justifyContent: "center",
    alignItems: "center",
  },
  playButton: {
    height: 50,
    width: 50,
    borderRadius: 25,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: colors.white,
  },
});
